import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import getProjectConditions from 'portal-modules/common/utils/get-project-conditions'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'
import { TPThemeContext } from 'portal-modules/common/context/theme-context'
const { isRP, isNotRP, isTP } = getProjectConditions()
const showEmbeddedView = getEmbeddedViewFlag()

const StyledPageHeader = styled('div')`
  ${({ theme, bgColor, isTransparent }) => {
    return {
      backgroundColor: getEmbeddedViewFlag()
        ? theme.embedded.background_color
        : 'transparent',
    }
  }};

  padding: ${({ hasTabs, isTransparent }) =>
    hasTabs && !showEmbeddedView
      ? '16px 8px 0'
      : showEmbeddedView
        ? '0 8px'
        : isRP
          ? isTransparent && '10px 8px 0'
          : '16px 8px'};

  @media only screen and (min-width: 380px) {
    padding: ${({ hasTabs, fromPayments }) =>
      fromPayments
          ? '0 24px'
        : hasTabs && !showEmbeddedView
          ? '24px 24px 0'
          : showEmbeddedView
            ? '0 8px'
            : isNotRP && '4px 24px'};
    margin-bottom: ${showEmbeddedView ? '4px' : 'initial'};
  }

  @media only screen and (max-width: 500px) {
    background-color: ${({ theme, isFromPayment }) =>
      (theme.mode.isDark &&
        isRP &&
        isFromPayment &&
        theme.mode.header_background_color)};
  }

  @media only screen and (min-width: 1619px) {
    width: ${isRP ? 'auto' : isTP ? '100%' : '65%'};
    display: ${isTP && 'flex'};
    flex-direction: ${({ sidebarPosition }) => 
      sidebarPosition === 'left' ? 'row' : 'row-reverse'};
    gap: ${isTP && '2%'};
    background: ${({ theme }) => theme.mode.background_color};
    align-items: ${isTP && 'flex-start'};
    justify-content: ${isTP && 'space-between'};
    padding: ${isTP && '0'};
      }
`

const PageHeader = ({ children, ...props }) => {
  const { sidebarPosition } = useContext(TPThemeContext)
  return (
    <StyledPageHeader sidebarPosition={sidebarPosition} {...props}>
      {children}
    </StyledPageHeader>
  )
}

PageHeader.propTypes = {
  hasTabs: PropTypes.bool,
  fromPayments: PropTypes.bool,
  children: PropTypes.node,
}

PageHeader.defaultProps = {
  fromPayments: false,
}

export default PageHeader
